import { useCallback, useContext, useEffect, useRef } from 'react'
import { LayoutContext } from '../../../context/layout-context'
import { queryClient } from '../../../state'
import { CheckoutInfo } from '../../../types'
import { ArtDetails } from '../art-details'
import { OrderPurchase } from '../order-purchase'
import { OrderTotals } from '../order-totals'
import {
  DetailsContent,
  ExplainContent,
  OrderDetailsContent,
  Explain,
  Title,
  ArtList,
} from './order-details.styled'
import { OrderDetailsProps } from './order-details.types'
import { useTranslation } from 'react-i18next'
import { useDescription } from '../../../hooks'

const NO_IMAGE = 0

export const OrderDetails: React.FC<OrderDetailsProps> = () => {
  const detailsContentRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const { payment_link: paymentLink } = queryClient.getQueryData([
    'checkout-info',
  ]) as CheckoutInfo

  const { setLayoutState } = useContext(LayoutContext)

  const handleOnClick = useCallback((event: MouseEvent) => {
    if (!detailsContentRef.current?.contains(event.target as HTMLElement)) {
      setLayoutState({ isOrderDetailsMobileShow: false })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const contentDom = contentRef.current
    if (contentDom) {
      contentDom.addEventListener('click', handleOnClick)
      return () => contentDom.removeEventListener('click', handleOnClick)
    }
  }, [handleOnClick])

  const { t } = useTranslation()
  const { description } = useDescription()

  const hasMerchantImage = !!paymentLink.merchant_image && paymentLink.merchant_image.replaceAll(' ', '').length > NO_IMAGE && paymentLink.merchant_image !== null

  return (
    <OrderDetailsContent ref={contentRef} hasMerchantImage={hasMerchantImage}>
      <DetailsContent ref={detailsContentRef}>
        <ExplainContent
          hasProducts={Boolean(
            paymentLink.additional_data.order?.items?.length
          )}
        >
          <Title>{t('Review your order')}</Title>
          {description && <Explain>{description}</Explain>}
        </ExplainContent>
        {paymentLink.additional_data.order?.items?.map((item, index) => (
          <ArtList key={index}>
            <ArtDetails {...item} />
          </ArtList>
        ))}
        <OrderTotals
          totalDue={paymentLink.amount.value}
          currency={paymentLink.amount.currency}
        />
        {paymentLink.additional_data.airline?.legs && (
          <OrderPurchase
            items={paymentLink.additional_data.airline.legs}
          />
        )}
      </DetailsContent>
    </OrderDetailsContent>
  )
}
